import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import PassengerCountInput from 'components/shared/PassengerCountInput';

import { Title, Container, PassengerCountGroup, ErrorMessageContainer } from './StandardExpandedSelection.styles';

const StandardExpandedSelection = ({ passengers, onChangePassengers, passengerRangeError }) => {
  const adultDescriptions = [
    <>
      Eurostar <FormattedMessage id="passengerTypes.adult" />
    </>,
    <>
      UK Rail <FormattedMessage id="passengerTypes.adult" />
    </>
  ];

  const childDescriptions = [
    <>
      Eurostar <FormattedMessage id="passengerTypes.child" />
    </>,
    <>
      UK Rail <FormattedMessage id="passengerTypes.child" />
    </>
  ];
  const twelveToFifteenDescriptions = [
    <>
      Eurostar <FormattedMessage id="passengerTypes.adult" />
    </>,
    <>
      UK Rail <FormattedMessage id="passengerTypes.child" />
    </>
  ];

  return (
    <Container data-cy="standard-expanded-selection">
      <Title>
        <FormattedMessage id="bookingMagnet.standardBookingTitle" />
      </Title>
      <PassengerCountGroup>
        <PassengerCountInput
          title={<FormattedMessage id="bookingMagnet.adults16Plus" />}
          value={passengers.adults16Plus}
          onChange={(count) => onChangePassengers({ adults16Plus: count })}
          maxCount={9}
          subtitles={adultDescriptions}
        />
        <PassengerCountInput
          title={<FormattedMessage id="bookingMagnet.adults12To15" />}
          value={passengers.adults12To15}
          onChange={(count) => onChangePassengers({ adults12To15: count })}
          maxCount={9}
          subtitles={twelveToFifteenDescriptions}
        />
        <PassengerCountInput
          title={<FormattedMessage id="bookingMagnet.children5To11" />}
          value={passengers.children5To11}
          onChange={(count) => onChangePassengers({ children5To11: count })}
          maxCount={9}
          subtitles={childDescriptions}
        />
        <PassengerCountInput
          title={<FormattedMessage id="bookingMagnet.children4Only" />}
          value={passengers.children4Only}
          onChange={(count) => onChangePassengers({ children4Only: count })}
          maxCount={9}
          subtitles={childDescriptions}
        />
      </PassengerCountGroup>
      <ErrorMessageContainer>{passengerRangeError && <FormattedMessage id={passengerRangeError} />}</ErrorMessageContainer>
    </Container>
  );
};

StandardExpandedSelection.propTypes = {
  passengers: PropTypes.shape({
    adults12To15: PropTypes.number.isRequired,
    adults16Plus: PropTypes.number.isRequired,
    children4Only: PropTypes.number.isRequired,
    children5To11: PropTypes.number.isRequired
  }).isRequired,
  onChangePassengers: PropTypes.func.isRequired,
  passengerRangeError: PropTypes.string
};

export default StandardExpandedSelection;
